// src/layouts/MainLayout.js
import Header from "../components/layouts/Header";
import Footer from "../components/layouts/Footer";
import WhatsappWidget from "../components/integrations/whatsapp";

const MainLayout = ({ children, settings }) => {
  return (
    <>
      <Header settings={settings} />
      {children}
      <Footer settings={settings} />
      <WhatsappWidget />
    </>
  );
};

export default MainLayout;
